import { render } from "./trade_result.vue?vue&type=template&id=6f941731"
import script from "./trade_result.vue?vue&type=script&lang=js"
export * from "./trade_result.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__